'use client'

import { useEffect, useState } from "react"

// False for a visitor who asked their system for less motion. The looping illustrations then
// show their finished state and stand still.
export function useMotionAllowed() {
  const [allowed, setAllowed] = useState(true)

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)')
    const update = () => setAllowed(!query.matches)
    update()
    query.addEventListener('change', update)
    return () => query.removeEventListener('change', update)
  }, [])

  return allowed
}
